<template>
  <div class="article ql-container ql-snow">
    <div v-if="!this.$route.query.id" class="list">
      <div class="listBody">
        <router-link v-for="(item,index) in announcementList" :key="index" class="listItem"
            :to="{name:'Article',query:{cat_id:cat_id,id:item.id}}">
          <div id="itemTitle">{{ item.title }}</div>
          <div id="itemDate">{{ item.add_time|moment }}</div>
          <div id="itemBtn">查看</div>
        </router-link>
      </div>
      <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="PageSize"
          :total="totalCount">
      </common-pagination>
    </div>
    <div v-else class="content">
      <router-link :to="{name:'Article',query:{cat_id:cat_id}}" class="contentBack">返回公告列表</router-link>
      <div id="flex">
        <div class="contentTitle">{{ announcementList[0].title }}</div>
        <div class="contentInfo">
          <div class="contentDate">发布时间：{{ announcementList[0].add_time|moment }}</div>
          <div class="contentClick">点击数：{{ announcementList[0].click }}</div>
        </div>
        <div id="content" v-html="announcementList[0].content"></div>
      </div>

    </div>
  </div>
</template>
<script>
import {apiArticleList} from "@/request/API";
import commonPagination from "@/components/commonPagination";

export default {
  name: '',
  props: {
    // id:this.$route.query.id,
    cat_id: String,
    id: Number
  },
  components: {
    commonPagination
  },
  data() {
    return {
      announcementList: [
        {title: ''}
      ],
      // 默认显示第几页
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 6,
      // 默认每页显示的条数（可修改）
      PageSize: 10,
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getArticleList(this.$route.query.id)
    },
    getArticleList(id) {
      apiArticleList({
        id: id,
        page: this.currentPage,
        PageSize: this.PageSize,
        cat_id: this.cat_id
      }).then(res => {
        this.announcementList = res.data.list
        this.totalCount = res.data.total
      })
    }
  },
  mounted() {
    this.getArticleList(this.$route.query.id)
  },
  watch: {
    cat_id(val, oldVal) {//普通的watch监听
      this.cat_id = val
      this.currentPage = 1
      this.getArticleList(this.$route.query.id)
    },
    id(val, oldVal) {//普通的watch监听]
      this.getArticleList(this.$route.query.id)
    },
  },
  computed: {},
}
</script>

<style scoped>
#content {
  overflow: auto;
  margin: 0;
  width: 100%;
  color: var(--text-main, #111827);
  font-size: 15px;
  line-height: 1.9;
}

#content >>> img {
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  border-radius: 4px;
}

</style>

<style lang='less' scoped>
.article {
  --article-min-height: ~"min(35vh, 420px)";
  border: none !important;
  min-height: var(--article-min-height);
  .list {
    min-height: var(--article-min-height);
    padding: 24px 30px 30px;
    background: var(--bg-card, #FFFFFF);
    box-sizing: border-box;
    .listBody{
      min-height: calc(var(--article-min-height) - 82px);
      box-sizing: border-box;
      .listItem {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 64px;
        margin-bottom: 14px;
        padding: 0 18px 0 22px;
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: 0 8px 20px rgba(26, 29, 36, 0.04);
        box-sizing: border-box;
        transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease, background .2s ease;

        #itemTitle {
          flex: 1;
          min-width: 0;
          margin-right: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 500;
          color: var(--text-main, #111827);
        }

        #itemDate {
          width: 116px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          white-space: nowrap;
        }

        #itemBtn {
          width: 76px;
          height: 32px;
          margin-left: 24px;
          background: var(--bg-tag, #F0EDE8);
          border-radius: 4px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #1A1D24);
        }
      }

      .listItem:hover {
        transform: translateY(-2px);
        border-color: var(--primary, #FF5A1F);
        background: var(--bg-section, #F7F5F2);
        box-shadow: 0 12px 28px rgba(26, 29, 36, 0.1);
      }
    }
  }

  .content {
    min-height: var(--article-min-height);
    background: var(--bg-card, #FFFFFF);
    padding: 24px 48px 56px;
    box-sizing: border-box;

    .contentBack {
      display: inline-flex;
      align-items: center;
      height: 32px;
      padding: 0 12px;
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #1A1D24);
      line-height: 32px;
      margin: 0 0 28px;
      cursor: pointer;
    }

    .contentBack:hover {
      color: #FFFFFF;
      background: var(--bg-dark, #1A1D24);
    }

    #flex {
      display: flex;
      flex-direction: column;
      align-items: center;

      .contentTitle {
        width: 100%;
        font-size: 26px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: var(--text-main, #111827);
        line-height: 36px;
        margin: 0 0 16px 0;
        text-align: center;
        word-break: break-word;
      }

      .contentInfo {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        min-height: 30px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 22px;
        margin: 0 0 28px 0;

        div {
          height: 30px;
          line-height: 30px;
          margin: 0 6px;
          padding: 0 12px;
          border-radius: 4px;
          background: var(--bg-section, #F7F5F2);
          border: 1px solid var(--border-soft, #E8E4DE);
        }
      }

      #content {
        padding-top: 28px;
        border-top: 1px solid var(--border-soft, #E8E4DE);
      }

      #signature {

      }
    }

  }
}
</style>
